import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';

export class SsoDialog {
	// Auth settings
	private authorizeEndpoint: string;

	// Dialog settings
	private title: string;
	private width: number = 800;
	private height: number = 800;

	// How often to check status of redirecting
	private interval: number = 500;

	// Event handlers
	private onClose: () => void;
	private onSuccess: (code: string) => void;
	private onFailure: (error: string, description: string) => void;

	constructor(authorizeEndpoint: string) {
		this.authorizeEndpoint = authorizeEndpoint;
	}

	get position() : [height: number, width: number] {
		const top = (screen.height / 2) - (this.height / 2);
		const left = (screen.width / 2) - (this.width / 2);

		return [top, left];
	}

	open() {
		const dialog = window.open(
			this.authorizeEndpoint,
			this.title,
			`width=${this.width},height=${this.height},top=${this.position[0]},left=${this.position[1]},popup=true`
		) as Window;

		const hasError = () => dialog.location.href.includes('error');
		const isComplete = () => {
			try {
				return dialog.location.href.startsWith(CognitoConfiguration.OpenIdConnectAuthorizeEndpoint.slice(0, -1));
			}
			catch (e) {
				return false;
			}
		};

		const ping = () => {
			let closed = false;

			try {
				closed = dialog.closed;
			}
			catch { }

			if (closed)
				this.onClose();
			else if (!isComplete())
				setTimeout(ping, this.interval);
			else {
				const url = new URL(dialog.location.href);
				const params = new URLSearchParams(url.search);
				if (hasError())
					this.onFailure(this.getError(params), this.getErrorDescription(params));
				else
					this.onSuccess(this.getAuthorizationCode(params));

				dialog.onclose = null;
				this.onClose();
				dialog.close();
			}
		};

		ping();
	}

	getAuthorizationCode(params: URLSearchParams): string {
		return params.get('code');
	}

	getError(params: URLSearchParams): string {
		return params.get('error');
	}

	getErrorDescription(params: URLSearchParams): string {
		return params.get('error_description');
	}
}